import type {
  AiConsultantAudioPostPayload,
  AiConsultantMessageAudioResult,
} from './ai-consultant-audio.backend-model';
import type { AiConsultantAudio } from './ai-consultant-audio.model';

export function transformAiConsultantAudio(
  response: AiConsultantMessageAudioResult,
  request: AiConsultantAudioPostPayload,
): AiConsultantAudio {
  return {
    id: request.input,
    input: request.input,
    audio: response.audio,
  };
}
